import React, { useEffect, useState } from 'react';
import {
  isAudioCaptionEnabled,
  setAudioCaptionEnabled,
  subscribeAudioCaptionEnabled,
} from '../../utils/audioCaptionPrefs';

const EnableAudioCaptionToggle = () => {
  const [enabled, setEnabled] = useState(() => isAudioCaptionEnabled());

  useEffect(() => subscribeAudioCaptionEnabled(setEnabled), []);

  const toggle = () => {
    setEnabled(setAudioCaptionEnabled(!enabled));
  };

  const hint = enabled
    ? 'On · caption mic is visible'
    : 'Off · caption mic is hidden';

  return (
    <div className="relative group/toggle flex-shrink-0">
      <button
        type="button"
        role="switch"
        aria-checked={enabled}
        aria-label="Enable audio"
        onClick={(e) => {
          e.stopPropagation();
          toggle();
        }}
        onMouseDown={(e) => e.stopPropagation()}
        onTouchStart={(e) => e.stopPropagation()}
        title={hint}
        className={`inline-flex items-center gap-1.5 rounded-lg border px-2 py-1 text-left transition-colors ${
          enabled
            ? 'border-primary-200 bg-primary-50 dark:border-primary-800 dark:bg-primary-900/40'
            : 'border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800'
        }`}
      >
        <span className="whitespace-nowrap text-[11px] font-semibold text-gray-900 dark:text-white">
          Audio
        </span>
        <span
          className={`relative h-4 w-7 flex-shrink-0 rounded-full transition-colors duration-200 ${
            enabled ? 'bg-primary-500' : 'bg-gray-300 dark:bg-gray-600'
          }`}
        >
          <span
            className={`absolute top-0.5 h-3 w-3 rounded-full bg-white shadow-sm transition-transform duration-200 ${
              enabled ? 'translate-x-3.5' : 'translate-x-0.5'
            }`}
          />
        </span>
      </button>
      <span className="pointer-events-none absolute left-0 bottom-full z-30 mb-1 hidden w-max max-w-[11rem] rounded-md bg-gray-900 px-2 py-1 text-[10px] leading-snug text-white shadow-lg group-hover/toggle:block">
        {hint}
      </span>
    </div>
  );
};

export default EnableAudioCaptionToggle;
